module.exports = __webpack_public_path__ + "static/media/internetExplorerIcon.20f6eb7f.png";